import ResetPassword from './ResetPassword';

const routes = [
	{
		name: 'resetPassword',
		path: '/resetpassword/:resetToken',
		component: ResetPassword
	}
];

export default routes;